import { render, staticRenderFns } from "./heatMap.vue?vue&type=template&id=10d24fea&scoped=true&"
import script from "./heatMap.vue?vue&type=script&lang=js&"
export * from "./heatMap.vue?vue&type=script&lang=js&"
import style0 from "./heatMap.vue?vue&type=style&index=0&id=10d24fea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d24fea",
  null
  
)

export default component.exports